import { combineReducers } from "redux";
import account from "./Account";
import dialog from "./Dialog";
import subscription from "./Subscription";
import marketplace from "./Marketplace";
import onboarding from "./Onboarding";
import user from "./User";
import timeWindow from "./TimeWindow";
import chat from "./ChatReducers";
import notificationBadge from "./NotificationBadgeReducers";
import message from "./MessageReducers";
import badge from "./BadgeReducers";
import emailsPrefs from './EmailPreferencesReducers'
import dashboard from "./Dashboard";
import integration from "./Integration";

const rootReducer = combineReducers({
  account,
  dialog,
  marketplace,
  onboarding,
  subscription,
  user,
  timeWindow,
  chat,
  notificationBadge,
  message,
  badge,
  emailsPrefs,
  dashboard,
  integration
});

export default rootReducer;
